/**
 * Core
 *
 * This imports the core vendor files into the site.
 * @Dan do not remove!
 */
import * as style from '../sass/core.scss'; // eslint-disable-line no-unused-vars
import jQueryUI from 'jquery-ui'; // eslint-disable-line no-unused-vars
import bootstrap from 'bootstrap'; // eslint-disable-line no-unused-vars
import nprogress from 'nprogress'; // eslint-disable-line no-unused-vars
// import 'whatwg-fetch'; // eslint-disable-line no-unused-vars
import Vue from 'vue'; // eslint-disable-line no-unused-vars
import '../../prod.env.js';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import * as Sentry from '@sentry/vue';
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Init global sentry
if(typeof Sentry != 'undefined') {
    Sentry.init({
        Vue,
        dsn: window.HOPPER_CONTEXT.config.sentryDsn,
        debug: false, // window.HOPPER_CONTEXT.config.environment !== 'production'
        environment: window.HOPPER_CONTEXT.config.environment,
        release: window.HOPPER_CONTEXT.rev,
        integrations: [
            new Sentry.BrowserTracing({
                beforeNavigate: (context) => {
                    return {
                        ...context,
                        name: location.pathname
                            .replace(/\/teams\/[^/]+/, '/teams/<teamId>'),
                    };
                },
            }),
        ],
        trackComponents: true,
        hooks: ['mount', 'update', 'destroy'],
        tracesSampleRate: 0.1,
        tracePropagationTargets: ['localhost', /^https:\/\/app.hopperhq.com\/api/,/^https:\/\/bunny.hopperhq.com\/api/],
    });
}


// Register service worker
// @todo disabled until s3 header resolved
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.getRegistrations().then(function(registrations){
            console.log('Unregistering service workers...');
            for (let registration of registrations) {
                registration.unregister();
            }
        });
    });
}
// if ('serviceWorker' in navigator) {
//     window.addEventListener('load', () => {
//         navigator.serviceWorker.register('/assets/build/service-worker-router.js', {scope: '/'})
//             .then(registration => {
//                 console.log('Service worker registered: ', registration); // eslint-disable-line no-console
//             })
//             .catch(registrationError => {
//                 console.error('Service worker registration failed', registrationError); // eslint-disable-line no-console
//             })
//         ;
//     });
// }


// Query string helper
window.updateQueryStringParam = function (key, value) {
    const baseUrl = `${location.protocol}//${location.host}${location.pathname}`;
    const urlQueryString = document.location.search;
    const newParam = `${key}=${value}`;
    let params = '?' + newParam;

    window.HOPPER_CONTEXT.query[key] = value;

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
        const removeRegex = new RegExp('([?&])' + key + '=[^&;]+[&;]?');
        const updateRegex = new RegExp('([?&])' + key + '[^&]*');

        if(typeof value === 'undefined' || value === null || value === '' ) { // Remove param if value is empty
            params = urlQueryString.replace(removeRegex, '$1');
            params = params.replace( /[&;]$/, '');
        } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
            params = urlQueryString.replace(updateRegex, '$1' + newParam);
        } else { // Otherwise, add it to end of query string
            params = urlQueryString + '&' + newParam;
        }
    }

    // no parameter was set so we don't need the question mark
    params = (params === '?') ? '' : params;
    window.history.replaceState({}, '', baseUrl + params);
};
